import React, { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';

import LockIcon from "../icons/lockIcon";
import CertifIcon from "../icons/certifIcon";
import PeopleConfIcon from "../icons/peopleConfIcon";
import PrivacyIcon from "../icons/privacyIcon";
import PartnersIcon from "../icons/partnersIcon.jsx";
import AvatarIcon from "../icons/avatarIcon";
import TableIcon from "../icons/tableIcon";
import EyeIcon from "../icons/eyeIcon";
import HelpIcon from "../icons/helpIcon";
import AccessManagementIcon from "../icons/accessManagementIcon";
import SvgMail from "../icons/mailIcon";
import { useSelector, useDispatch } from "react-redux";
import Http from "../../commons/utils/Http";

import MiniTour from "../components/MiniTour";

import { setFirstAccess } from '../../store/actions/userLoginActions';

export default () => {
    const { Item } = Menu;

    const { userData } = useSelector(state => state.userLogin);
    const dispatch = useDispatch();

    const [startTour, setStartTour] = useState(false);

    const location = useLocation();

    const {permissions} = useSelector(state => state.userLogin);
    
    const modules = permissions[0] ? permissions[0].modules : [];
    const screensArray = [];
    for (let moduleObj of modules) {
        screensArray.push(moduleObj.screen_name);
    }

    useEffect(() => {
        if (userData.first_access) {
            setStartTour(true);
            dispatch(setFirstAccess(false));
            updateUser(userData.id);
        }
    }, [userData]);

    window.startTour = () => {
        setStartTour(true);
    }

    async function updateUser(userId) {
        const body = {
            "id": userId,
            "first_access": false,
        };

        try {
            let response = await Http.put(`/users`, body, Http.headers);
            return response;
        } catch (e) {
            return null;
        };
    }

    function renderScreens() {
        const screens = [];

        if (screensArray.includes("Usuários")) {
            screens.push(
                <Item key="/users"><Link to="/users"><PeopleConfIcon
                    className={"menu-icon"}/><span>Administração e pessoas</span></Link></Item>
            )
        }
        
        if (screensArray.includes("Gestão de Acessos")) {
            screens.push(
                <Item key="/gestao-acessos"><Link to="/gestao-acessos"><AccessManagementIcon
                    className={"menu-icon"}/><span>Gestão de acessos</span></Link></Item>
            )
        }

        if (screensArray.includes("Certificações")) {
            screens.push(
                <Item key="/certifications"><Link to="/certifications"><CertifIcon
                    className={"menu-icon"}/><span>Certificações</span></Link></Item>
            )
        }

        if (screensArray.includes("Parceiros")) {
            screens.push(
                <Item key="/partners"><Link to="/partners"><PartnersIcon
                    className={"menu-icon"}/><span>Parceiros</span></Link></Item>
            )
        }

        if (screensArray.includes("Aplicações")) {
            screens.push(
                <Item key="/applications"><Link to="/applications"><EyeIcon
                    className={"menu-icon"}/><span>Aplicações</span></Link></Item>
            )
        }

        if (screensArray.includes("Notificações")) {
            screens.push(
                <Item key="/notifications"><Link to="/notifications"><SvgMail
                    className={"menu-icon"}/><span>Notificações</span></Link></Item>
            )
        }

        if (screensArray.includes("Feedbacks")) {
            screens.push(
                <Item key="/feedbacks"><Link to="/feedbacks"><HelpIcon
                    className={"menu-icon"}/><span>Feedbacks</span></Link></Item>
            )
        }

        if (screensArray.includes("Roles")) {
            screens.push(
                <Item key="/roles"><Link to="/roles"><HelpIcon
                    className={"menu-icon"}/><span>Roles</span></Link></Item>
            )
        }

        if (screensArray.includes("Módulos")) {
            screens.push(
                <Item key="/modules"><Link to="/modules"><HelpIcon
                    className={"menu-icon"}/><span>Módulos</span></Link></Item>
            )
        }

        if (screensArray.includes("Funções")) {
            screens.push(
                <Item key="/functions"><Link to="/functions"><HelpIcon
                    className={"menu-icon"}/><span>Funções</span></Link></Item>
            )
        }

        return screens.map(s => s);

    }

    function renderAdminSection() {
        if (screensArray.length > 0) {
            return (
                <Menu.ItemGroup key="g2" title="ADMINISTRAÇÃO" className={"ant-menu-group-administration"}>
                    {renderScreens()}
                </Menu.ItemGroup>
            )
        }
    }

    return (
        <Menu mode="inline" style={{marginTop: 30}} selectedKeys={[location.pathname]}>
            <Menu.ItemGroup key="g1" title="MEUS DADOS" className={"ant-menu-group-data-user"}>
                <Item key="/dadospessoais" className="item-menu-data-user">
                    <Link to="/dadospessoais">
                        <AvatarIcon className={"menu-icon"}/>
                        <span>Meu ID</span>
                    </Link>
                </Item>
                <Item key="/seguranca-login" className="item-menu-security-login">
                    <Link to="/seguranca-login">
                        <LockIcon className={"menu-icon"}/>
                        <span>Segurança e login</span>
                    </Link>
                </Item>
                <Item key="/my-permissions" className="item-menu-my-permissions">
                    <Link to="/my-permissions">
                        <TableIcon className={"menu-icon"}/>
                        <span>Minhas permissões</span>
                    </Link>
                </Item>
                <Item key="/privacy">
                    <Link to="/privacy" className="item-menu-privacy">
                        <PrivacyIcon className={"menu-icon"} />
                        <span>Privacidade - LGPD</span>
                    </Link>
                </Item>
            </Menu.ItemGroup>

            <Menu.Divider style={{margin: "24px 30px"}}/>

            {renderAdminSection()}

            <MiniTour start={startTour}/>

        </Menu>
    )
}
